import { rem, radius, token } from '@thiememeulenhoff/lit-sdk';
import { css } from 'lit';
import { tagName } from '../../helpers';

export const tag = tagName('skeleton');

export const styles = [
  css`
    :host {
      animation: pulse 2s ease-in-out 0.5s infinite;
      background-color: var(--color-skeleton);
      block-size: 1.2em;
      block-size: 100%;
      display: block;
      inline-size: 100%;
      max-inline-size: 100%;
      position: relative;

      --color-skeleton: ${token('skeleton-background-default')};
      --border-radius: ${rem(6)};
    }

    :host([variant='text']) {
      block-size: auto;
      border-radius: var(--border-radius);

      .skeleton:empty:before {
        content: '\\00a0';
      }
    }

    :host([variant='circle']) {
      border-radius: ${radius('extra-large')};
    }

    :host([variant='rounded']) {
      border-radius: var(--border-radius);
    }

    @keyframes pulse {
      0% {
        opacity: 1;
      }
      50% {
        opacity: 0.4;
      }
      100% {
        opacity: 1;
      }
    }
  `,
];
